import React, { useEffect, useState } from 'react';
import Classes from '../Cart.module.css';
import { FormControlLabel, Radio } from '@mui/material';

const LeftArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height='15px' fill='#353535' viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
)

export default function BillingInfo({ setIsShowBillingInfo, billing, setBilling }) {


    return (
        <div className={Classes.billing}>
            <div className={Classes.header} style={{ marginBottom: '2rem' }}>
                <div className='flexAlign10'>
                    <div
                        className={Classes.closeBtn}
                        style={{ background: 'rgb(245, 245, 245)', display: 'flex' }}
                        onClick={() => setIsShowBillingInfo(false)}
                    >
                        <LeftArrow />
                    </div>
                    <div className={Classes.flex}>
                        <h3>Confirm Order</h3>
                    </div>
                </div>
            </div>

            <div className={Classes.flexColGroup}>
                <div className={Classes.flexCol1}>
                    <label className={Classes.label}>First name</label>
                    <input
                        type="text"
                        className={Classes.inputField}
                        placeholder="John"
                        value={billing?.firstName}
                        onChange={(e) => setBilling({ ...billing, firstName: e.target.value })}
                        required
                    />
                </div>
                <div className={Classes.flexCol1}>
                    <label className={Classes.label}>Last name</label>
                    <input
                        type="text"
                        className={Classes.inputField}
                        placeholder="Doe"
                        value={billing?.lastName}
                        onChange={(e) => setBilling({ ...billing, lastName: e.target.value })}
                    />
                </div>
            </div>

            <div className={Classes.flexCol1}>
                <label className={Classes.label}>Phone</label>
                <input
                    type="text"
                    className={Classes.inputField}
                    placeholder="Phone"
                    value={billing?.phone}
                    onChange={(e) => setBilling({ ...billing, phone: e.target.value })}
                    required
                />
            </div>

            <div className={Classes.flexCol1}>
                <div className="flexAlign10">
                    <label className={Classes.label}>Email</label>
                    <div className={Classes.optionalText}><h5>Optional</h5></div>
                </div>
                <input
                    type="text"
                    className={Classes.inputField}
                    placeholder="johndoe@example.com"
                    value={billing?.email}
                    onChange={(e) => setBilling({ ...billing, email: e.target.value })}
                />
            </div>

            <div className={Classes.flexCol1}>
                <label className={Classes.label}>Billing address</label>
                <input
                    type="text"
                    className={Classes.inputField}
                    placeholder="Address/street/house/apartment"
                    value={billing?.address1}
                    onChange={(e) => setBilling({ ...billing, address1: e.target.value })}
                    required
                />
            </div>

            <div className={Classes.flexCol1}>
                <input
                    type="text"
                    className={Classes.inputField}
                    placeholder="Address line 2"
                    value={billing?.address2}
                    onChange={(e) => setBilling({ ...billing, address2: e.target.value })}
                />
            </div>

            <div className={Classes.flexColGroup}>
                <div className={Classes.flexCol1}>
                    <input
                        type="text"
                        className={Classes.inputField}
                        placeholder="City"
                        value={billing?.city}
                        onChange={(e) => setBilling({ ...billing, city: e.target.value })}
                        required
                    />
                </div>
                <div className={Classes.flexCol1}>
                    <input
                        type="text"
                        className={Classes.inputField}
                        placeholder="State / Province"
                        value={billing?.state}
                        onChange={(e) => setBilling({ ...billing, state: e.target.value })}
                    />
                </div>
                <div className={Classes.flexCol1}>
                    <input
                        type="text"
                        className={Classes.inputField}
                        placeholder="Postal / Zip Code"
                        value={billing?.zip}
                        onChange={(e) => setBilling({ ...billing, zip: e.target.value })}
                    />
                </div>
            </div>

            <div className={Classes.flexCol1}>
                <label className={Classes.label}>Payment Method</label>
                <div className={Classes.cod}>
                    <Radio
                        checked={billing?.paymentMethod === 'cod'}
                        onChange={() => setBilling({ ...billing, paymentMethod: 'cod' })}
                        sx={{
                            width: 30,
                            color: '#353535',
                            '&.Mui-checked': {
                                color: '#353535',
                            },
                        }}
                        size="small"
                    />
                    <h5>COD (Cash on Delivery)</h5>
                </div>
            </div>

            <button type='submit' className={Classes.checkoutBtn}>
                <h5>Order via Whatsapp</h5>
            </button>
        </div>
    );
}
